import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import api from '../services';
import { IMG_BASE_URL } from '../Helpers'
import BookGrid from './BookGrid';
import BookSlider from './BookSlider';
export default function RelatedBook({ categoryId, bookId }) {
    const [relatedBooks, setRelatedBooks] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        if (categoryId) {
            fetchRelatedBooks(categoryId);
        }
    }, [categoryId]);

    const fetchRelatedBooks = async (categoryId) => {
        try {
            const data = await api("GET", `booksByCategory/${categoryId}`);
            const filteredData = data.filter((book) => book.book_id.toString() !== bookId.toString());
            setRelatedBooks(filteredData);
        } catch (error) {
            console.error("Error fetching related books:", error);
        }
    };

    if (!relatedBooks.length) {
        return null;
    }

    return (
        <>
            {relatedBooks.length > 0 && (
                <BookSlider books={relatedBooks} sliderTitle="Related Books" />
            )}
        </>
    )
}
